// extracted by mini-css-extract-plugin
module.exports = {"root":"Events_root__3Tglg"};